import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import request from '@/routes/api/api_conextion';
import axios from "axios"; // eslint-disable-next-line no-unused-vars

import { getFromLocal, saveInLocal } from "@/commons/utils/storage";

function getResourece(resource) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Promise(function (resolve) {
    setTimeout(function () {
      request({
        url: resource,
        method: 'get',
        params: params
      }).then(function (request) {
        // saveInLocal(resource, request)
        resolve(request);
      });
    }, 1000);
  });
}

export function getEstadoCivil() {
  return _getEstadoCivil.apply(this, arguments);
}

function _getEstadoCivil() {
  _getEstadoCivil = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", getResourece('/marital-status'));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getEstadoCivil.apply(this, arguments);
}

export function getSucursales(_x) {
  return _getSucursales.apply(this, arguments);
}

function _getSucursales() {
  _getSucursales = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", getResourece('/sucursales/' + id));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getSucursales.apply(this, arguments);
}

export function getTipoViviendas() {
  return _getTipoViviendas.apply(this, arguments);
}

function _getTipoViviendas() {
  _getTipoViviendas = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", getResourece('/properties'));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getTipoViviendas.apply(this, arguments);
}

export function getEstudios() {
  return _getEstudios.apply(this, arguments);
}

function _getEstudios() {
  _getEstudios = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", getResourece('/studies'));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getEstudios.apply(this, arguments);
}

export function getFormasDeEnterarse() {
  return _getFormasDeEnterarse.apply(this, arguments);
}

function _getFormasDeEnterarse() {
  _getFormasDeEnterarse = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", getResourece('/find-out'));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getFormasDeEnterarse.apply(this, arguments);
}

export function getRelacionesLaborales() {
  return _getRelacionesLaborales.apply(this, arguments);
}

function _getRelacionesLaborales() {
  _getRelacionesLaborales = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", getResourece('/employment-relations'));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getRelacionesLaborales.apply(this, arguments);
}

export function getCoinTypes() {
  return _getCoinTypes.apply(this, arguments);
}

function _getCoinTypes() {
  _getCoinTypes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", getResourece('/coinTypes'));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getCoinTypes.apply(this, arguments);
}

export function getSelds() {
  return _getSelds.apply(this, arguments);
}

function _getSelds() {
  _getSelds = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", getResourece('/workers'));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getSelds.apply(this, arguments);
}

export function getVentasTop() {
  return _getVentasTop.apply(this, arguments);
}

function _getVentasTop() {
  _getVentasTop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", getResourece('/ventasTop'));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _getVentasTop.apply(this, arguments);
}

export function getDepartamentos() {
  return _getDepartamentos.apply(this, arguments);
}

function _getDepartamentos() {
  _getDepartamentos = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", getResourece('/departamentos'));

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _getDepartamentos.apply(this, arguments);
}

export function getBancos() {
  return _getBancos.apply(this, arguments);
}

function _getBancos() {
  _getBancos = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", getResourece('/bancos'));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _getBancos.apply(this, arguments);
}

export function getRubros() {
  return _getRubros.apply(this, arguments);
}

function _getRubros() {
  _getRubros = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt("return", getResourece('/rubros'));

          case 1:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _getRubros.apply(this, arguments);
}

export function getMunicipios(_x2) {
  return _getMunicipios.apply(this, arguments);
}

function _getMunicipios() {
  _getMunicipios = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(params) {
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", getResourece('/getMunicipios/' + params));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _getMunicipios.apply(this, arguments);
}

export function getLocalidad(_x3) {
  return _getLocalidad.apply(this, arguments);
}

function _getLocalidad() {
  _getLocalidad = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(params) {
    return regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt("return", getResourece('/getLocalidad/' + params));

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _getLocalidad.apply(this, arguments);
}

export function getMunicipiosByName(_x4) {
  return _getMunicipiosByName.apply(this, arguments);
}

function _getMunicipiosByName() {
  _getMunicipiosByName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(params) {
    return regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt("return", getResourece('/municipio/' + params));

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _getMunicipiosByName.apply(this, arguments);
}

export function getLocalidadByName(_x5) {
  return _getLocalidadByName.apply(this, arguments);
}

function _getLocalidadByName() {
  _getLocalidadByName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(params) {
    return regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt("return", getResourece('/localidad/' + params));

          case 1:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _getLocalidadByName.apply(this, arguments);
}

export function getDepartamentoByName(_x6) {
  return _getDepartamentoByName.apply(this, arguments);
}

function _getDepartamentoByName() {
  _getDepartamentoByName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(params) {
    return regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt("return", getResourece('/departamento/' + params));

          case 1:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _getDepartamentoByName.apply(this, arguments);
}

export function getDocumentsType(_x7) {
  return _getDocumentsType.apply(this, arguments);
}

function _getDocumentsType() {
  _getDocumentsType = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(params) {
    var active,
        _args18 = arguments;
    return regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            active = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : true;
            return _context18.abrupt("return", getResourece('/documents/' + params + '/' + active));

          case 2:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _getDocumentsType.apply(this, arguments);
}

export function getPaises(_x8) {
  return _getPaises.apply(this, arguments);
}

function _getPaises() {
  _getPaises = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(params) {
    return regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", getResourece('/getPaises', params));

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _getPaises.apply(this, arguments);
}

export function getPais(_x9) {
  return _getPais.apply(this, arguments);
}

function _getPais() {
  _getPais = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(id) {
    return regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            return _context20.abrupt("return", getResourece('/getPaises/' + id));

          case 1:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _getPais.apply(this, arguments);
}

export function getDirectionConfig() {
  return _getDirectionConfig.apply(this, arguments);
}

function _getDirectionConfig() {
  _getDirectionConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
    return regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            return _context21.abrupt("return", getResourece('/direction/config'));

          case 1:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _getDirectionConfig.apply(this, arguments);
}

export function getFormasPago() {
  return _getFormasPago.apply(this, arguments);
}

function _getFormasPago() {
  _getFormasPago = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
    return regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            return _context22.abrupt("return", getResourece('/getFormasPago'));

          case 1:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _getFormasPago.apply(this, arguments);
}

export function getDocIde(_x10) {
  return _getDocIde.apply(this, arguments);
}

function _getDocIde() {
  _getDocIde = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(id) {
    return regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            return _context23.abrupt("return", getResourece('/getdocide/' + id));

          case 1:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _getDocIde.apply(this, arguments);
}

export function getInstantorSettings() {
  return _getInstantorSettings.apply(this, arguments);
}

function _getInstantorSettings() {
  _getInstantorSettings = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
    return regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            return _context24.abrupt("return", getResourece('/instantor/config'));

          case 1:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _getInstantorSettings.apply(this, arguments);
}

export function getRequisitos(_x11) {
  return _getRequisitos.apply(this, arguments);
}

function _getRequisitos() {
  _getRequisitos = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(id) {
    return regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            return _context25.abrupt("return", getResourece('/requisitosgarante/' + id));

          case 1:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));
  return _getRequisitos.apply(this, arguments);
}

export function validateContact(_x12, _x13, _x14) {
  return _validateContact.apply(this, arguments);
}

function _validateContact() {
  _validateContact = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(email, phone, document) {
    return regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            return _context26.abrupt("return", getResourece('/validarcontacto?' + 'email=' + email + '&phone=' + phone + '&document=' + document));

          case 1:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
  return _validateContact.apply(this, arguments);
}

export function getIp() {
  return _getIp.apply(this, arguments);
}

function _getIp() {
  _getIp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
    return regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            return _context27.abrupt("return", axios.create({
              baseURL: process.env.VUE_APP_IPL_URL,
              // url = base url + request url
              // withCredentials: true, // send cookies when cross-domain requests
              timeout: 5000 // request timeout

            }).get('/json'));

          case 1:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _getIp.apply(this, arguments);
}

export function getMotivoRechazo(_x15) {
  return _getMotivoRechazo.apply(this, arguments);
}

function _getMotivoRechazo() {
  _getMotivoRechazo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(loan) {
    var ruta;
    return regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            ruta = loan ? '/getmotivorechazo/' + loan : '/getmotivorechazo';
            return _context28.abrupt("return", getResourece(ruta));

          case 2:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
  return _getMotivoRechazo.apply(this, arguments);
}